import { jsx as _jsx } from "react/jsx-runtime";
import { Grid } from "@mantine/core";
import { Children } from "react";
export const TabWithChildren = ({ children, span = { base: 12 } // Default to full width
 }) => {
    const childrenArray = Children.toArray(children);
    return (_jsx(Grid, { gutter: "xs", children: childrenArray.map((child, index) => (_jsx(Grid.Col, { span: span, children: child }, index))) }));
};
